import '../Styles/Dashboard.css';
import { AiOutlineSearch } from 'react-icons/ai';
import Navbar from '../Components/Navbar';
import { useTranslation } from 'react-i18next';
import { IoCloseSharp } from "react-icons/io5";
import bckg from "../Images/order.svg"
import {RiShoppingCartFill } from 'react-icons/ri';
function CashBack(props) {
   
    const { t, i18n } = useTranslation();


    return (
        <div > 
         
        <div onClick={()=>props.setModal(false)} className="modalOverlay"></div>
        <div  className="modal-content" style={{height:"auto",width:"40vw ",minWidth:"337px",paddingTop:"2em",position:"fixed"}}>
       <p className='alrt'>{i18n.language=="ar"?"سيتم أضافة مبلغ الهدية لمحفظتك عند استلامك للطلب":"Gift amount will added  to your wallet after receiving your order"}</p>

       {props.button?
       <div className='modalBtns' style={{marginTop:"2em"}}>
<button  onClick={()=>{props.createOrder(); props.setModal(false)}}  className='del'>{t("menu.continue")}</button>
<button  onClick={()=>{props.setSubmitLoading(false); props.setModal(false); }}  className='cls'>{t("profile.cancel")}</button>

</div>:null}


        </div>
      </div>
  
    );
  }
  
  export default CashBack;
  
  